import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum SpecialFeeState {
    PENDING,
    DECLINED,
    CONFIRMED,
}

export namespace SpecialFeeState {
    type Data = {
        text: string;
        color: string;
        icon: string;
    };

    export const Record: Record<SpecialFeeState, Data> = {
        [SpecialFeeState.PENDING]: {
            text: 'Prüfung ausstehend',
            color: 'warning',
            icon: 'mdi-clock-outline',
        },
        [SpecialFeeState.DECLINED]: {
            text: 'Abgelehnt',
            color: 'error',
            icon: 'mdi-close',
        },
        [SpecialFeeState.CONFIRMED]: {
            text: 'Bestätigt',
            color: 'success',
            icon: 'mdi-check',
        },
    };

    export const Items = mapRecordToItems(Record);
}
